const ContactUs = {

    // FIELDS
    search: 'Search',

    // PAGE HEADER
    contact_us: 'Contact Us',

    // TABLE HEADER
    table_name: 'NAME',
    table_email: 'EMAIL',
    table_mobile: 'MOBILE',
    table_contact_about: 'CONTACT ABOUT',
    table_subject: 'SUBJECT',
    table_status: 'STATUS',
    table_submitted_on: 'SUBMITTED ON',

    // ACTION
    view_contact: 'View Contact',

    // DETAILS MODAL
    details_title: 'Contact Us Details',
    details_error: 'Unable to load contact details.',
    contact_information: 'Contact Information',
    name: 'Name',
    email: 'Email',
    mobile: 'Mobile',
    contact_about: 'Contact About',
    subject: 'Subject',
    description: 'Description',
    status: 'Status',
    submitted_on: 'Submitted On',

}

export default ContactUs;